const Work = {
  state: {
    loadingWork: false,
    reports: [
      {
        title: "MOBIS Assistants",
        description:
          "MOBIS Assistants is an AI-powered assistant on web, TikTok, Instagram, Facebook, and WhatsApp to help customer service teams answer driver questions about car rentals, including booking, pricing, availability, and schedules.",
        web_url: "https://global-mobility-service.co.id/mobis/",
        github_url: "https://github.com/BintangMy",
        codeTools: [
          "n8n",
          "OpenAi",
          "Firebase",
          "PHP",
          "Laravel",
          "MariaDB",
          "Composer",
          "JavaScript",
          "Whatsapp API",
          "Instagram API",
          "Facebook API",
          "TikTok API",
        ],
        img: "mobis.png",
      },
      {
        title: "MCCS Mobile",
        description:
          "MCCS Mobile is an IoT-based mobile application designed for real-time vehicle monitoring, management, and security. The app integrates with GPS and telematics devices to track vehicle location, view trip history, control vehicle functions remotely, manage subscriptions, and receive real-time notifications through a modern and user-friendly interface.",
        web_url: "https://github.com/BintangMy",
       github_url: "https://github.com/BintangMy",
        codeTools: [
          "Dart",
          "Flutter",
          "Http",
          "GetX",
          "Firebase",
          "PHP",
          "Laravel",
          "MariaDB",
          "Composer",
          "Android Studio",
          "Firebase Cloud Messaging",
          "Open Street Map",
          "Docker",
          "MCCS API",
        ],
        design: null,
        img: "mccs_mobile.png",
      },

      {
        title: "LPK Mobile | LPK Web User",
        description:
          "LPK is a mobile and web application that connects users with Vocational Training Institutions (LPK). The application provides payments, notifications, schedule reminders, and other features to support students' learning activities.",
        web_url: "https://www.youtube.com/watch?v=hGfUDRpYQ9o",
        github_url: "https://github.com/BintangMy",
        codeTools: [
          "Dart",
          "Flutter",
          "Http",
          "GetX",
          "Firebase",
          "PHP",
          "Laravel",
          "MariaDB",
          "Composer",
          "Android Studio",
        ],
        img: "lpk_mobile.png",
      },

      {
        title: "LPK Back Office",
        description:
          "LPK Back Office is a web platform that connects Vocational Training Institutions (LPK) with students and facilitates registration and job placement in Japan. Features include CRUD for Students, LPKs, Contracts, Payments, Notifications, Roles, and Permissions.",
        web_url: "https://www.youtube.com/watch?v=hGfUDRpYQ9o",
        github_url: "https://github.com/BintangMy",
        codeTools: [
          "Vue.js",
          "Vue Router",
          "Vite",
          "Vuetify",
          "TagCloud",
          "ESLint",
          "Axios",
          "JWT Decode",
          "Pinia",
          "PHP",
          "Laravel",
          "MariaDB",
          "Composer",
        ],
        img: "lpk_bo.png",
      },

      {
        title: "Tire AI Checker",
        description:
          "Tire AI Checker is an AI-powered mobile and web application that monitors tire health in real time using computer vision and machine learning. It detects tire pressure, wear level, cracks, and potential risks, providing notifications and predictive maintenance reports.",
        web_url:
          "https://drive.google.com/file/d/1d-jAL4hE1H23IVKvisPc86dDBVO91UbY/view",
        github_url: "https://github.com/BintangMy",
        codeTools: [
          "LLM",
          "TensorFlow Lite",
          "OpenCV",
          "Python (FastAPI)",
          "Firebase",
          "Node.js",
          "PHP",
          "Laravel",
        ],
        img: "tire_ai.png",
      },

      {
        title: "Fleet Management System",
        description:
          "FMS is a web and mobile application designed to help businesses efficiently manage vehicle fleets with real-time monitoring and operational insights.",
        web_url: "https://fleet-management-system.co.id/account/login",
        github_url: "https://github.com/BintangMy",
        codeTools: [
          "Vue.js",
          "Vue Router",
          "Vite",
          "Vuetify",
          "TagCloud",
          "ESLint",
          "Axios",
          "JWT Decode",
          "Pinia",
          "PHP",
          "Laravel",
          "MariaDB",
          "Composer",
          "OpenStreetMap",
        ],
        img: "fms.png",
      },
     {
        title: "UltraGPT",
        description:
          "UltraGPT is a web-based AI application designed to assist users in various creative and technical tasks. With its advanced capabilities, UltraGPT can generate text summaries, write paragraphs in specific styles, create programming code, build interactive chatbots, and generate images automatically. This application is highly useful for users who want to save time and effort in creative and technical endeavors.",
        web_url: "https://ultragpt.vercel.app/",
        github_url: "https://github.com/BintangMy/web_GPT",
        codeTools: ["Next.js", "Redux", "Express.js", "Node.js", "PostgresQL", "Axios", "Sequelize", "Tailwind", "CSS", "Open.Ai", "Eslint"],
        img: "ultraGPT.png",
      },
      {
        title: "Al-Qur'an",
        description:
          "This application provides a reading feature of the Qur'an which contains 30 juz verses of the Qur'an, listening to murottal, a collection of prayers and hadiths and prayer schedules throughout Indonesia",
        web_url: "https://alqurann.netlify.app/",
        github_url: "https://github.com/BintangMy/Al-Quran",
        codeTools: ["React.js", "Redux", "Vite", "Tailwind", "Kemenag API"],
        design: "Design by Kuadran",
        img: "al-quran.png",
      },
      {
        title: "Nihon No Live",
        description:
          "Nihon No Live, a web application which can help promote the latest products and songs made by the vtuber agency, which on the website displays the home page, existing talents and a list of songs that has been released by the talent, then on the merchandise page that is being sold, and there is also a special membership page where users can watch live streams and can interact directly with live talent/ vtubers.",
        web_url: "https://www.youtube.com/watch?v=WOoiQRJ_UEc",
        github_url: "https://github.com/Holotiv8",
        codeTools: [
          "React.js",
          "Redux",
          "Redux-Thunk",
          "CSS-3",
          "Tailwind CSS",
          "React-Router",
          "Zegocloud",
          "Express.js",
          "PostgreSQL",
          "Jwt",
          "Axios",
          "Sequelize.js",
          "Redis",
          "Jest",
          "Supertest",
        ],
        img: "nihonolive.png",
      },
      {
        title: "My Movie",
        description:
          "My Movie is a movie streaming platform that provides services to watch movies online for free. Users can access various types of films, ranging from the latest films, classic films, to currently popular films of various genres, such as action, adventure, drama, comedy, romance, horror, and many more.",
        web_url: "https://www.youtube.com/watch?v=xOhlWG9-VD8",
        github_url: "https://github.com/BintangMy/myMovie",
        codeTools: [
          "React.js",
          "Redux",
          "Vite",
          "Tailwind CSS",
          "Node.js",
          "Express.js",
          "PostgresQL",
          "Sequelize.js",
          "TMDB",
        ],
        img: "mymovie.png",
      },
      {
        title: "Twotter",
        description:
          "TWOtter is a social media website similar to Twitter, but with anonymous user identities. Users can interact, share opinions, and express themselves freely without revealing their identity. The platform is a choice for those who want to speak freely without disclosing their identity and provides a safe and open social media space for diverse opinions and ideas.",
        web_url: "twotterhacktiv8.netlify.app",
        github_url: "https://github.com/BintangMy/twotter0.1 ",
        codeTools: ["HTML", "CSS", "Tailwind CSS", "JavaScript", "Figma"],
        img: "twotter.png",
      },
      {
        title: "Bi Food",
        description:
          "BI FOOD is a web app that offers Indonesian cuisine with an attractive interface and easy online ordering features. Users can choose dishes, view detailed information, and track food delivery in real-time. The platform introduces and promotes the richness of Indonesian culinary to the world, with authentic food quality and efficient delivery service.",
        web_url:
          "https://www.instagram.com/p/CaUH8q-vAipP_PmjaEClGUoBhoyeyBrwEcqHvs0/ ",
        github_url: "https://github.com/BintangMy/BI_FOOD",
        codeTools: ["HTML", "CSS", "Tailwind CSS", "JavaScript", "Figma"],
        img: "bifood.png",
      },
      {
        title: "BaTam",
        description:
          "BATAM Lokal is a website that provides pick-up and delivery services for goods in the Bekasi Tambun area and its surroundings. With an easy-to-use platform, users can easily input delivery details and estimate shipping costs. BATAM Lokal offers fast and reliable delivery by an experienced team, with responsive customer support. This service provides practical and efficient solutions for users in need of pick-up and delivery services in the Bekasi and Tambun area.",
        web_url: "https://batamlokal.netlify.app/",
        github_url: "https://github.com/BintangMy/BaTamLokal",
        codeTools: ["HTML", "CSS", "Bootstrap CSS", "JavaScript", "Figma"],
        img: "batam-lokal.png",
      },
    ],
  },
  mutations: {
    SET_LOADING_WORK(state, payload) {
      state.loadingWork = payload;
    },
  },
  actions: {},
};

export default Work;
